import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import masterTcService from "services/Setup/Master/masterTcService";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  masterTcList: {},
};

export const getMasterTcList = createAsyncThunk(
  "masterTc/getMasterTcList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await masterTcService.getMaterTcList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const masterTc = createSlice({
  name: "masterTc",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder

      //list
      .addCase(getMasterTcList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getMasterTcList.fulfilled, (state, action) => {
        state.loading = false;
        state.masterTcList = action.payload;
      })
      .addCase(getMasterTcList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, hideNotification, showLoading } =
  masterTc.actions;

export default masterTc.reducer;
